export default {
  setMenuActive(state, data) {
    changeMenuActive(state, data)
  },
  setCourseActive(state, data) {
    changeCourseActive(state, data)
  },
  setCourse(state, data) {
    changeCourse(state, data)
  },
  setPartList(state, data) {
    changePartList(state, data)
  },
  setGroup(state, data) {
    changeGroup(state, data)
  },
  setIndexActive(state, data) {
    changeIndexActive(state, data)
  },
  setBread(state, data) {
    changeBread(state, data)
  },
  setDefinition(state, data) {
    changeDefinition(state, data)
  },
  setPlayAuth(state, data) {
    changePlayAuth(state, data)
  },
  setSubCourse(state, data) {
    changeSubCourse(state, data)
  },
  setInfomationStatus(state, data) {
    changeInfomationStatus(state, data)
  }
}

function changeMenuActive(state, data) {
  for (var i = 0; i < data.length; i++) {
    data[i] = Number(data[i])
  }
  state.MenuActive = data
}

function changeCourseActive(state, data) {
  state.CourseActive = data
}

function changeCourse(state, data) {
  state.Course = data
}
function changePartList(state, data) {
  state.PartList = data
}
function changeGroup(state, data) {
  state.Group = data
}
function changeIndexActive(state, data) {
  state.IndexActive = data
}
function changeBread(state, data) {
  state.Bread = data
}
function changeDefinition(state, data) {
  state.Definition = data
}
function changePlayAuth(state, data) {
  state.PlayAuth = data
}
function changeSubCourse(state, data) {
  state.SubCourse = data
}
function changeInfomationStatus(state, data) {
  state.InfomationStatus = data
}